import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';

import {
  TDelayedMarkSavedSearchAsReadDesktopRequest,
  TDelayedMarkSavedSearchAsReadDesktopResponse,
  fetchDelayedMarkSavedSearchAsReadDesktop,
} from 'shared/repositories/saved-searches/v1/delayed-mark-saved-search-as-read-desktop';

export function readAllOffersForSavedSearches(
  httpApi: IHttpApi,
  parameters: TDelayedMarkSavedSearchAsReadDesktopRequest,
  logger: ILogger,
) {
  return fetchDelayedMarkSavedSearchAsReadDesktop<
    TDelayedMarkSavedSearchAsReadDesktopResponse,
    TDelayedMarkSavedSearchAsReadDesktopResponse
  >({ httpApi, parameters }).then(response => {
    if (response.statusCode !== 200) {
      const error = new Error('Failed send /v1/delayed-mark-saved-search-as-read-desktop/');

      logger.error(error);
    }
  });
}
